var map = {
	"./IMG_0034_small.jpg": 3876,
	"./IMG_0053_small.jpg": 101,
	"./aile_poulet.jpg": 3562,
	"./banfan-small-gallerie.jpg": 8615,
	"./banfan_crevettes.jpg": 897,
	"./banfan_poulet.jpg": 2421,
	"./boeuf_braisé.jpg": 6087,
	"./boulettes_poisson.jpg": 1574,
	"./brioche_chinoise.jpg": 4467,
	"./bubble-tea-brown-sugar-small-gallerie.jpg": 2207,
	"./bubble_tea_brown_sugar.jpg": 4981,
	"./bubble_tea_classique.jpg": 4779,
	"./bubble_tea_matcha.jpg": 1622,
	"./crevettes_tomates.jpg": 9137,
	"./dou_liang.jpg": 1795,
	"./favicon.jpg": 5126,
	"./gai_fan_crevettes.jpg": 3790,
	"./gai_fan_pois.jpg": 76,
	"./gai_fan_poulet.jpg": 5383,
	"./lait_coco_tapiocas.jpg": 4578,
	"./mojito_classique.jpg": 9905,
	"./mojito_fraise.jpg": 3948,
	"./mojito_pastèque.jpg": 6025,
	"./mojito_thé_noir.jpg": 1907,
	"./nouilles-2-small-gallerie.jpg": 7,
	"./nouilles-3-small-gallerie.jpg": 5556,
	"./nouilles-4.jpg": 5902,
	"./nouilles-5.jpg": 7170,
	"./nouilles-small-gallerie.jpg": 7746,
	"./nouilles_froides_ciboulette.jpg": 5252,
	"./nouilles_froides_poulet.jpg": 4886,
	"./nouilles_porc_pois_casses.jpg": 1886,
	"./oeuf_braise.jpg": 3241,
	"./piment-2-small-gallerie.jpg": 4773,
	"./piment-2.jpg": 3300,
	"./piment-small-gallerie.jpg": 5457,
	"./piment.jpg": 9002,
	"./poivron_corne_boeuf.jpg": 9158,
	"./porc_frit.jpg": 2675,
	"./poudre_pimentée.jpg": 2445,
	"./poulet_os_piment_vert.jpg": 1358,
	"./poulet_os_pimenté.jpg": 7232,
	"./raviolis-small-gallerie.jpg": 5147,
	"./riz_sauté.jpg": 8064,
	"./salade_boeuf_braisé.jpg": 9032,
	"./salade_concombre.jpg": 3397,
	"./sauce_soja_sucrée.jpg": 4052,
	"./saucisse_chinoise.jpg": 712,
	"./soupe_nouilles_classiques.jpg": 4458,
	"./soupe_nouilles_patate_douce.jpg": 5188,
	"./soupe_nouilles_riz.jpg": 308,
	"./tang_zhi_gan_lu.jpg": 678,
	"./taro_thé_lait.jpg": 8131,
	"./te_se_liang_mian.jpg": 1794,
	"./thé-jasmin-fraise-coco-small-gallerie.jpg": 2289,
	"./thé_fruits_pétillant.jpg": 1612,
	"./thé_infusé_froid_passion_citron.jpg": 6577,
	"./thé_infusé_froid_passion_mangue.jpg": 3197,
	"./thé_jasmin_crème_fouettée.jpg": 2021,
	"./thé_jasmin_fraises.jpg": 5707,
	"./thé_jasmin_fraises_coco.jpg": 392,
	"./thé_jasmin_mangue.jpg": 9733,
	"./thé_jasmin_pastèque.jpg": 3636,
	"./thé_noir_crème_fouettée.jpg": 8625,
	"./tofu-master-gallerie.jpg": 7376,
	"./tofu_du_chef.jpg": 6039,
	"./tofu_gonflé.jpg": 5353,
	"./tofu_surimi.jpg": 199,
	"./travers_porc_ail.jpg": 3600,
	"./travers_porc_caramel.jpg": 6633,
	"./tripes_porc.jpg": 5456,
	"./viande-hachee-small-gallerie.jpg": 2078,
	"./viande_hachée_porc.jpg": 922,
	"./wontons-gallerie.jpg": 959,
	"./wontons.jpg": 3802,
	"./wontons_frits.jpg": 6485,
	"./yang_zhi_gan_lu.jpg": 709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;